import { db } from "../../utils/firebase";

// get all projects
export const getAllResources = async () => {
  const querySnapshot = await db
    .collection("resources")
    .orderBy("title", "asc")
    .get();

  const data = { current: [], past: [] };
  querySnapshot.forEach((doc) => {
    let { title, externalLink, thumbnail, summary} = doc.data()

    data.current.push({ title, externalLink, thumbnail, summary });

  });

  return data;
};
